<template lang="pug">
div#main
  .posts.content
    section.post(v-for="post in posts")
      post(v-bind:post-prop="post")
    section.post(v-if="componentLoaded && posts.length === 0")
      div Woops! There are no more posts!
  nav(class="pagination is-right")
    a(class="pagination-previous" v-if="currentPage > 1" v-on:click="previousPage" href="#") Previous Page
    a(class="pagination-next" v-if="posts.length == 10" v-on:click="nextPage" href="#") Next Page
    ul(class="pagination-list")
      li
</template>

<script>
import postService from '@/services/postsService';
import Post from '@/components/Post.vue';

export default {
  name: 'Blog',
  components: {
    Post,
  },
  data() {
    return {
      posts: [],
      currentPage: 1,
      componentLoaded: false,
    };
  },
  watch: {
    $route() {
      this.loadPage();
    },
    posts() {
      console.log(this.posts)
    }
  },
  methods: {
    nextPage() {
      if (this.posts.length === 10) this.$router.push({ name: 'blog page', params: { page: ++this.currentPage } });
    },
    previousPage() {
      if (this.currentPage > 1) this.$router.push({ name: 'blog page', params: { page: --this.currentPage } });
    },
    loadPage() {
      postService.loadPage(this.currentPage);
    },
  },
  created() {

  },
  mounted() {
    if (this.$route.params.page) {
      this.currentPage = this.$route.params.page;
    }
    if (!this.componentLoaded) {
      postService.$on('loadPage', (posts) => {
        this.posts = posts;
        this.componentLoaded = true;
      });
    }
    postService.$on('deletePost', () => {
      this.loadPage();
    });

    this.loadPage();
  },
};
</script>
